import { Alignment, DivNumberInput } from "@/components/DivInput/DivNumberInput"
import { Edge, PointLike } from "@antv/x6"
import { useState } from "react"
import isNumber from "lodash/isNumber";
import { mm2px, px2mm } from "@/utils/size"
import { isPoint } from "@/components/FlowSheetEditor/events/helper"


interface PointsEditorProps {
  unit: Edge
}
export const PointsEditor = (props: PointsEditorProps) => {
  const {unit} = props
  const start = unit.getSource()
  const end = unit.getTarget()
  const vertices = unit.getVertices()
  const [points, setPoints] = useState(px2mmForPoints([start, ...vertices, end]))
  
  const onPointChange = (point, index) => {
    const oldPoint = points[index];
    if (!isPoint(oldPoint)) {
      return;
    }
    const pxPoint = mm2pxForPoint(point)
    const newPoints = [...points]
    newPoints[index] = pxPoint
    setPoints(newPoints)
    if (index === 0) {
      unit.setSource(pxPoint)
    } else if (index === points.length -1 ) {
      unit.setTarget(pxPoint)
    } else {
      unit.setVertexAt(index - 1, pxPoint)
    }
  }

  return <table className="bordered-table">
    <thead>
      <th scope="col" style={{width: 20}}>Index</th> 
      <th scope="col" style={{minWidth: 200}}>X(mm)</th> 
      <th scope="col" style={{minWidth: 200}}>Y(mm)</th>  
    </thead>
    <tbody>
      {points.map((item, index) => <tr>
        <td>{index + 1}</td>
        <td>
          {isNumber(item.x) ? <DivNumberInput
            value={item.x as number}
            removeAble={false}
            align={Alignment.Center}
            style={{width: '100%'}}
            onChange={(val) => onPointChange({...item, x: val}, index)}
          /> : '-'}
      </td>
        <td>
          {isNumber(item.y) ? <DivNumberInput
            value={item.y as number}
            removeAble={false}
            align={Alignment.Center}
            style={{width: '100%'}}
            onChange={(val) => onPointChange({...item, y: val}, index)}
          /> : '-'}
        </td>
      </tr>)}
    </tbody>
  </table>
}

function px2mmForPoints(points: Array<any>) {
  return points.map(item => {
    const {x, y} = item;
    if (!(isNumber(x) && isNumber(y))) {
      return item;
    }
    return {
      x: px2mm(x),
      y: px2mm(y)
    }
  })
}

function mm2pxForPoint(point: PointLike) {
  const {x, y} = point;
  return {
      x: mm2px(x),
      y: mm2px(y)
    }
}